<div class="modal-header">
  <h4 class="modal-title"> {{'settingsTabNavigator.label.cover_label_strip_settings' | translate}} </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <form [formGroup]="form">
      <div class="mb-3 row">
        <label class="col-md-3 col-form-label">{{'settingsTabNavigator.label.article_length' | translate}}:</label>
        <div class="col-md-9">
          <input type="text" spellcheck="false" class="form-control" id="articleLength" formControlName="articleLength"
            inputRestricter="^[0-9\.,]*$" (inputEvent)="form.controls.articleLength.setValue($event)"
            [class.is-invalid]="form.controls.articleLength.invalid && form.controls.articleLength.touched">
          <div class="invalid-feedback">{{form.controls.articleLength.errors?.messageKey | translate}}</div>
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-3 col-form-label">{{'settingsTabNavigator.label.article_offset' | translate}}:</label>
        <div class="col-md-9">
          <input type="text" spellcheck="false" class="form-control" id="articleOffset" formControlName="articleOffset"
            inputRestricter="^[0-9\.,]*$" (inputEvent)="form.controls.articleOffset.setValue($event)"
            [class.is-invalid]="form.controls.articleOffset.invalid && form.controls.articleOffset.touched">
          <div class="invalid-feedback">{{form.controls.articleOffset.errors?.messageKey | translate}}</div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.close' | translate}}</button>
  <button class="btn btn-primary btn-forward" (click)="save()" [disabled]="!form.valid">{{'global.label.save' | translate}}</button>
</div>
